import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GTAG_ID = 'AW-18170306000';
const PROTECTED_PREFIXES = ['/user-home', '/system'];
const SCRIPT_ID = 'gtag-js-src';

function isLoggedIn() {
  try {
    return !!localStorage.getItem('authToken');
  } catch (_) {
    return false;
  }
}

function isProtectedPath(pathname) {
  return PROTECTED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/')
  );
}

function injectGtag() {
  if (document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GTAG_ID);
}

function removeGtag() {
  const script = document.getElementById(SCRIPT_ID);
  if (script && script.parentNode) {
    script.parentNode.removeChild(script);
  }
  try {
    delete window.gtag;
    delete window.dataLayer;
  } catch (_) {
    window.gtag = undefined;
    window.dataLayer = undefined;
  }
}

export default function GoogleAdsTag() {
  const { pathname } = useLocation();

  useEffect(() => {
    const eligible = !isLoggedIn() && !isProtectedPath(pathname);
    if (eligible) {
      injectGtag();
      if (typeof window.gtag === 'function') {
        window.gtag('config', GTAG_ID, { page_path: pathname });
      }
    } else {
      removeGtag();
    }
  }, [pathname]);

  return null;
}
